import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateGroupHeader = (props) => {
  const { id, mykey, jenis_mobil, merek, nomor_polisi, tahun } =
    props.group_data;

  return <></>;
};

export default ReportTemplateGroupHeader;
